import PropTypes from 'prop-types';
// material-ui
import { useColorScheme, useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';
import logo from 'assets/images/fieldnavi_logo.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

export default function Logo({ dark = false, width = "150" }) {
  const { colorScheme } = useColorScheme();
  // Using the new FieldNavi Logo
  return (
    <img src={logo} alt="FieldNavi" width={width} />
  );
}

Logo.propTypes = { dark: PropTypes.bool };
